/**
 * Created by Bart Decorte
 * Date: 2019-08-20
 * Time: 11:16
 */
import Dropzone from '../components/uploads/Dropzone';
import DropzoneModal from './DropzoneModal';

export default class CsvImportModal extends DropzoneModal {
  constructor() {
    const rootEl = document.querySelector('#modal-csv');
    const dropzoneEl = rootEl.querySelector('.js-dropzone-wrap');
    const dropzone = new Dropzone(dropzoneEl, {
      fileRules: [
        'text/csv',
        'application/vnd.ms-excel',
        'application/csv',
        'text/x-csv',
        'application/x-csv',
        'text/comma-separated-values',
        'text/x-comma-separated-values'
      ],
    });
    super(rootEl, dropzone);
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/modals/CsvImportModal.js